import type { IconProps } from '../types/IconProps.ts';
export const SimCard: IconProps = {
    name: 'SimCard',
    children: [
        `<path d="M3 4c0-1.1.9-2 2-2h9.35a2 2 0 0 1 1.62.83l4.65 6.42a2 2 0 0 1 .38 1.18V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />`,
        `<rect width="8" height="9" x="8" y="9" rx=".5" />`,
        `<path d="M12 9v2.98q0 .02.02.02H16M8.5 15h3.48q.02 0 .02.02V18" />`,
    ]
};